<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div [ngClass]="{'subBlockContainer': !setFullWindow , 'subBlockContainer_full':setFullWindow}" *ngIf="orders">
  <div class="pageTitle">
    {{title}}
    <i class="material-icons pullfloat-right" [routerLink]="['/myOrder']">close</i>
  </div>
  <div class="subBlockContent">
    <div class="order_header">
      <input class="order_search_input" type="text" [(ngModel)]="searchField" placeholder="Search onSearch on order number or purchase order number" (keyup.enter)="searchOrder()">
      <div class="order_search_icon" (click)="searchOrder()">
        <i class="fas fa-search fa-lg"></i>
      </div>
    </div>
    <div class="my-orders-body" *ngIf="orders">
      <table class="table table-hover table-dark">
        <thead>
          <!-- 	ORDER		ORDER STATUS	HOLD REASON	QTY	TOTAL(EX)	DOCUMENTS -->
          <tr>
            <th scope="col" style="width: 5%">ORDER</th>
            <th scope="col" style="width: 10%">RESELLER PO</th>
            <th scope="col" style="width: 10%">STATUS</th>
            <th scope="col" style="width: 10%">STOCK CODE</th>
            <th scope="col" style="width: 15%">STOCK DESCRIPTION</th>
            <th scope="col" style="width: 10%">LINE QTY</th>
            <th scope="col" style="width: 10%">ALLOC QTY</th>
            <th scope="col" style="width: 10%">B/O QTY</th>
            <th scope="col" style="width: 10%">ETA</th>
            <th scope="col" style="width: 10%">ETA Code</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let order of orders">
            <ng-container *ngIf="orders">
              <tr>
                <th><a [routerLink]="['orderitemdetail/'+ order?.orderNo]" (click)="watchOrder(order)">{{order?.orderNo}}</a></th>
                <td>{{order?.resellerPO}}</td>
                <td>{{order?.orderStatus}}</td>
                <td>{{order?.stockCode}}</td>
                <td>{{order?.stockDesc}}</td>
                <td>{{order?.lineQty}}</td>
                <td>{{order?.allocQty}}</td>
                <td>{{order?.backOrderQty}}</td>
                <td>{{order?.eta}}</td>
                <td>{{order?.etaCode}}</td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
      <!-- <pagination-controls (pageChange)="renderPagingOrder($event)" directionLinks="true" previousLabel="" nextLabel="" class="search-pagination"
      *ngIf="showPager"></pagination-controls> -->
    </div>
  </div>
</div>

<div #entry>
  <router-outlet></router-outlet>
</div>